import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FlatButton from 'material-ui/FlatButton';
import { translate, showNotification as showNotificationAction } from 'admin-on-rest';
import { push as pushAction } from 'react-router-redux';
import { refreshView as refreshViewAction } from 'admin-on-rest';
import restClient from '../restClient';

class DeleteLogsButton extends Component {
    handleClick = () => {
        restClient('DELETE_ALL', 'admin/deletealllog', {action: 'delete_all'} )
			   .then((response) => {
				  	showNotificationAction('aor.notification.updated','confirm');
					   
					pushAction('/admin/adminlog');
					this.props.refreshView();
				})
				.catch((e) => {
					console.error(e);
					showNotificationAction('cloudhitns.error_try_again','warning')
				});
    }

    render() {
        return <FlatButton label="Delete 1000 logs" onClick={this.handleClick} />;
    }
}

DeleteLogsButton.propTypes = {
    push: PropTypes.func,
    record: PropTypes.object,
    showNotification: PropTypes.func,
};

export default connect(null, {
    showNotification: showNotificationAction,
    push: pushAction,
	refreshView: refreshViewAction
})(DeleteLogsButton);


// WEBPACK FOOTER //
// ./src/adminlog/DeleteLogsButton.js